import React from 'react';
import {Header} from 'semantic-ui-react';

export default ({children}) => (
	<Header as="h1" align="center">
		{children}
	</Header>
);
